module.exports = __webpack_public_path__ + "img/中国职工文化体育协会@2x.81025358.png";